/**
 * Utility function to ensure all cases are handled in switch statements.
 * @param {never} value
 * @throws {Error}
 * @returns {never}
 */
export const checkExhaustiveness = (value) => {
  throw new Error(`Unhandled case: ${value}`)
}
